module.exports = __webpack_public_path__ + "media/images/covers/foundation/cambridge-students-a7ba21310f3a5f255f5f9dd45abfcdd0.jpg";